var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 3.125H16.4062C17.2174 3.125 17.875 3.78258 17.875 4.59375V16.4062C17.875 17.2174 17.2174 17.875 16.4062 17.875H4.59375C3.78258 17.875 3.125 17.2174 3.125 16.4062V4.59375C3.125 3.78258 3.78258 3.125 4.59375 3.125Z",
    stroke: "#6C757D",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactiveIcon.39b3f7ba33f1eb7db166dbe4ad54b977.svg";
export { ForwardRef as ReactComponent };